var React = require('react');

function Icon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z","key":0}),React.createElement("path",{"d":"M0-.25h24v24H0z","fill":"none","key":1})]);
}

Icon.defaultProps = {"fill":"#000000","height":"24","viewBox":"0 0 24 24","width":"24"};

module.exports = Icon;

Icon.default = Icon;
